import { Group, ImageField, NodeField, ParagraphsField, SaveBar, getPath } from "@/admin/fields";

const AboutTab = ({ content, update, saving, dirty, message, onSave }) => {
  const approachItems = getPath(content, ["about", "approach", "items"]) || [];
  const valueItems = getPath(content, ["about", "values", "items"]) || [];

  return (
    <div data-testid="admin-tab-content-about">
      <SaveBar tabId="about" saving={saving} dirty={dirty} message={message} onSave={onSave} />

      <Group title="Page Header" open>
        <div className="af-grid-2">
          <NodeField content={content} update={update} label="Title start" path={["about", "titleStart"]} />
          <NodeField content={content} update={update} label="Title accent (green)" path={["about", "titleAccent"]} />
        </div>
        <NodeField content={content} update={update} label="Intro" path={["about", "intro"]} multiline />
      </Group>

      <Group title="Who We Are">
        <ImageField
          label="Section image"
          value={getPath(content, ["about", "image"])}
          onChange={(value) => update(["about", "image"], value)}
          testId="admin-about-image-field"
        />
        <div className="af-grid-2">
          <NodeField content={content} update={update} label="Heading line 1" path={["about", "lead", "title1"]} />
          <NodeField content={content} update={update} label="Heading line 2" path={["about", "lead", "title2"]} />
        </div>
        <NodeField content={content} update={update} label="Heading accent (green)" path={["about", "lead", "accent"]} />
        <ParagraphsField
          label="Paragraphs"
          items={getPath(content, ["about", "lead", "paragraphs"]) || []}
          onChange={(items) => update(["about", "lead", "paragraphs"], items)}
        />
      </Group>

      <Group title="How We Work">
        <NodeField content={content} update={update} label="Section title" path={["about", "approach", "title"]} />
        <NodeField content={content} update={update} label="Section intro" path={["about", "approach", "intro"]} multiline />
        {approachItems.map((item, index) => (
          <div className="af-grid-2" key={index}>
            <NodeField content={content} update={update} label={`Item ${index + 1} title`} path={["about", "approach", "items", index, "title"]} />
            <NodeField content={content} update={update} label="Body" path={["about", "approach", "items", index, "body"]} multiline />
          </div>
        ))}
      </Group>

      <Group title="What Guides Us">
        <NodeField content={content} update={update} label="Section title" path={["about", "values", "title"]} />
        {valueItems.map((item, index) => (
          <div className="af-grid-2" key={index}>
            <NodeField content={content} update={update} label={`Value ${index + 1} title`} path={["about", "values", "items", index, "title"]} />
            <NodeField content={content} update={update} label="Body" path={["about", "values", "items", index, "body"]} multiline />
          </div>
        ))}
      </Group>

      <Group title="Bottom Banner">
        <div className="af-grid-2">
          <NodeField content={content} update={update} label="Banner heading" path={["about", "banner", "heading"]} />
          <NodeField content={content} update={update} label="Banner text" path={["about", "banner", "text"]} multiline />
        </div>
      </Group>
    </div>
  );
};

export default AboutTab;
